module.exports = __webpack_public_path__ + "static/scale-model-of-chattanooga-ghost-tours-inc-in-chattanooga-tennessee-2aa10a0460b75c3ab34aaa789606253f.png";